import R from "ramda";
import { useCookie } from "react-recipes";
import { useSelector } from "react-redux";

import { useOffersActions } from "store/OffersSlice";
import useRouter from "hooks/useRouter";
import useOfferGroups from "hooks/useOfferGroups";

const OFFER_COOKIE_EXPIRE_DAYS = 14;

const useOffers = () => {
  const { loadOffer } = useOffersActions();
  const { defaultOffer, loadOfferGroups } = useOfferGroups();
  const { offer } = useSelector((state) => state.OffersSlice);

  const {
    query: { offer: queryOffer = null },
  } = useRouter();

  const [currentOfferId, setCurrentOfferId] = useCookie("offer");

  const setCurrentOffer = () => {
    if (!R.isNil(queryOffer)) {
      setCurrentOfferId(queryOffer, OFFER_COOKIE_EXPIRE_DAYS);
    }
  };

  const loadCurrentOffer = async () => {
    if (R.isNil(currentOfferId)) {
      await loadOfferGroups();
    } else {
      try {
        await loadOffer(currentOfferId);
      } catch {
        await loadOfferGroups();
      }
    }
  };

  return {
    currentOffer: offer || defaultOffer,
    loadOffer,
    setCurrentOffer,
    loadCurrentOffer,
  };
};

export default useOffers;
